import { DnaStats } from "./Stats";

export default DnaStats;
